import { isStrategicReferralPartner } from '@ecomm/checkout/utils'
import { useIsD2DCart } from '@ecomm/data-cart/getters/useIsD2DCart'
import { useLocale } from '@ecomm/data-hooks'

import { useFoundSimpliSafeThroughQuery } from '@ecomm/checkout/data'
import { useMemo } from 'react'
import { FormCheckbox } from '../FormCheckbox'
import { FormField } from '../FormField'
import { FormSelect } from '../FormSelect'
import { FormTextInput } from '../FormTextInput'
import { getShuffledLeadSources } from './leadSources'

/**
 * Port of the CustomerService component used on the jotai shipping page.
 * https://simplisafe.atlassian.net/browse/ECP-10079
 */
export function CustomerService() {
  const locale = useLocale()

  const {
    options,
    title: foundInfoThroughTitle,
    placeholder: foundInfoThroughPlaceholder
  } = useFoundSimpliSafeThroughQuery()

  const shuffledOptions: readonly string[] = useMemo(
    () => getShuffledLeadSources(options),
    [options]
  )

  const isD2DCart = useIsD2DCart()

  return isStrategicReferralPartner() || isD2DCart ? null : (
    <fieldset
      className="rounded-base my-6 flex w-full flex-col gap-1 border border-solid border-neutral-200 p-6"
      data-component="CheckoutFormCustomerService"
    >
      <div className="flex flex-col">
        <legend className="font-bold ">
          Where did you hear about SimpliSafe?
        </legend>
        <span className="mb-1 mt-1.5 text-neutral-dark">(Optional)</span>
      </div>
      <div className="flex flex-col gap-4 md:flex-row">
        <FormField
          className="w-full grow"
          id="foundInfoThrough"
          label={foundInfoThroughTitle}
        >
          <FormSelect
            name="foundInfoThrough"
            options={shuffledOptions}
            placeholder={foundInfoThroughPlaceholder}
          />
        </FormField>
        <div className="flex w-full grow flex-col">
          <FormField
            className="w-full grow"
            id="additionalFoundInfoThrough"
            label="Additional details"
          >
            <FormTextInput
              id="additionalFoundInfoThrough"
              maxLength={64}
              name="additionalFoundInfoThrough"
              placeholder="Please provide any details"
            />
          </FormField>
          <div className="text-sm text-neutral-dark">
            e.g. tv show you were watching or magazine name
          </div>
        </div>
      </div>
      {locale === 'en-GB' ? (
        <FormField className="mt-4" id="epsilonAbacusOptIn">
          <FormCheckbox
            label="Tick this box to receive the latest products and offers by post from select third party partners"
            name="epsilonAbacusOptIn"
          />
        </FormField>
      ) : null}
    </fieldset>
  )
}
